const arrendamientoEnganches = {
  path: "enganches",
  name: "enganches",
  component: () =>
    import(
      /* webpackChunkName: 'Dashboard-Enganches-Root' */ "@/modules/dashboard/pages/enganches"
    ),
};

export default arrendamientoEnganches;
